import React from 'react'
import ServiceLocator from 'live/services/service-locator'
import authorization from 'live/services/authorization'

import { withSuspenseWrapper } from '../components/SuspenseWrapper'

const WrapperKPIServices = withSuspenseWrapper(React.lazy(() => import('./KpiService/KPIService')))
const WrapperKPIGoalsByRig = withSuspenseWrapper(React.lazy(() => import('./KpiGoals/index')))
const WrapperKPIGoalsByWell = withSuspenseWrapper(React.lazy(() => import('./byWell/kpiGoalsByWell')))

const hasPermissionToView =
    authorization.superAdmin ||
    authorization.admin ||
    authorization.Permission.ADMIN ||
    authorization.Permission.OGPERFORMANCE_MANAGE_KPI ||
    authorization.Permission.OGPERFORMANCE_ADMINISTRATE_KPI ||
    authorization.Permission.OGPERFORMANCE_VIEW_KPI

// KPI Service. hideCard: true — this section renders its own plain header and independent
// Section Cards (F-04 redesign), so it must not also be wrapped in the platform's CardContainer
// border/shadow (see plugin-kpi-core's KPIOptionsRegistryEntry.hideCard).
hasPermissionToView &&
    ServiceLocator.getService('kpi-options-service').then(service => {
        service.register({
            assetType: 'rig',
            title: null,
            subtitle: null,
            hideCard: true,
            body: WrapperKPIServices
        })
    })

// Hide/Show goals by rig. hideCard: true — same reasoning as KPI Service above.
hasPermissionToView &&
    ServiceLocator.getService('kpi-options-service').then(service => {
        service.register({
            assetType: 'rig',
            title: null,
            subtitle: null,
            hideCard: true,
            body: WrapperKPIGoalsByRig
        })
    })

// KPI Goals in Well
hasPermissionToView &&
    ServiceLocator.getService('kpi-options-service').then(service => {
        service.register({
            assetType: 'wells',
            title: null,
            subtitle: null,
            body: WrapperKPIGoalsByWell
        })
    })
